import React, { useState, useEffect, useCallback, useRef } from "react";
import IterationContainer from "./IterationContainer";
import { MdOutlineAdd } from "react-icons/md";

import "./RepeatPopup.css";

function RepeatPopup({
  open,
  setOpen,
  iterations,
  setIterations,
  workingIteration,
  setWorkingIteration,
  top,
  left,
}) {
  const popupRef = useRef();
  let mouseInside = false;
  const [renaming, setRenaming] = useState();

  useEffect(() => {
    setTimeout(() => {
      if (open) {
        window.addEventListener("click", handleClick);
        window.addEventListener("mousedown", handleMouseDown);
      } else {
        window.removeEventListener("click", handleClick);
        window.removeEventListener("mousedown", handleMouseDown);
        setRenaming(-1);
      }
    }, 100);
  }, [open]);

  const handleClick = useCallback((e) => {
    if (
      popupRef.current &&
      !popupRef.current.contains(e.target) &&
      !mouseInside
    )
      setOpen(false);
  }, []);

  // this prevents the popup from closing when the user drags the mouse
  // out of it after initiating mousedown (e.g. when highlighting text
  // in the text fields and releasing the mouse outside of the main container)
  const handleMouseDown = useCallback((e) => {
    if (popupRef.current && popupRef.current.contains(e.target))
      mouseInside = true;
    else mouseInside = false;
  }, []);

  const addIteration = () => {
    let newIteration = `Repeat ${iterations.length + 1}`;
    setIterations([...iterations, newIteration]);
    console.log(iterations.length);
  };

  return (
    <div
      ref={popupRef}
      className={`repeat-popup ${open ? "visible" : "hidden"}`}
      style={{
        top: `calc(${top}px + ${open ? "40px" : "50px"})`,
        left: `calc(${left}px - 150px)`,
        zIndex: 999,
      }}
    >
      <div className="header">
        <h5>Set repeats</h5>
      </div>
      <div className="body">
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="iteration-button add" onClick={addIteration}>
            <MdOutlineAdd size={"1em"} style={{ color: "#2b4e7e" }} />
            <p>Add new</p>
          </div>
        </div>
        <div
          className="iteration-name-button"
          style={{
            display: "flex",
            height: "1.75em",
            margin: "0.25em 0",
            backgroundColor: workingIteration === -1 ? "#a9d6bc" : "",
            boxShadow:
              workingIteration === -1 ? "inset 0 1px 2px 0 #00000040" : "",
          }}
          onClick={() => {
            setWorkingIteration(-1);
          }}
        >
          <p style={{ margin: "0 0.25em 0 0" }}>0.</p>Main sequence
        </div>
        {iterations.map((iteration, i) => {
          return (
            <IterationContainer
              key={i}
              i={i}
              iterations={iterations}
              setIterations={setIterations}
              workingIteration={workingIteration}
              setWorkingIteration={setWorkingIteration}
              renaming={renaming}
              setRenaming={setRenaming}
            />
          );
        })}
      </div>
    </div>
  );
}

export default RepeatPopup;
